var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}warn-34`,"viewBox":"0 0 34 34"}},[_c('circle',{staticClass:"sign border",attrs:{"cx":"17","cy":"17","r":"16","stroke-width":"2","fill":"none"}}),_c('circle',{staticClass:"sign circle",attrs:{"cx":"17","cy":"17","r":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }